import ACTIONS from "../actions/BillingReportActions";
import _ from "lodash";

const initialState = {
    showDownloadMessage: false,
    downloadMessageData: {},
    showRunMessage: false,
    runMessageData: {},
    sapFileUploadData: {},
    showUlSpinner: false,
    showMrSpinner: false,
    showRpSpinner: false,
    showRbSpinner: false,
    showDbSpinner: false,
    showDsSpinner: false,
    uploadSapWarning: false,
}

const BillingReportReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.billingReportsActionTypes.SHOW_DB_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showDbSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_DS_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showDsSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_UL_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showUlSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_MR_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showMrSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_RP_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showRpSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_RB_LOADING: {
            let newState = _.cloneDeep(state);
            newState.showRbSpinner = true;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_DOWNLOAD_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.showDownloadMessage = true;
            newState.downloadMessageData = action.payload.data;
            newState.showDbSpinner = false;
            newState.showDsSpinner = false;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.SHOW_RUN_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.showRunMessage = true;
            newState.runMessageData = action.payload.data;
            newState.showUlSpinner = false;
            newState.showMrSpinner = false;
            newState.showRpSpinner = false;
            newState.showRbSpinner = false;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.HIDE_DOWNLOAD_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.showDownloadMessage = false;
            newState.downloadMessageData = {};
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.HIDE_RUN_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.showRunMessage = false;
            newState.runMessageData = {};
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.UPDATE_SAP_UPLOAD_STATUS: {
            let newState = _.cloneDeep(state);
            newState.sapFileUploadData = action.payload.data;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.TOGGLE_UPDATE_SAP_WARNING: {
            let newState = _.cloneDeep(state);
            newState.uploadSapWarning = !newState.uploadSapWarning;
            return newState;
        }

        case ACTIONS.billingReportsActionTypes.CLEAR_BILLING_REPORT_DETAILS: {
            return initialState;
        }

        default:
            return state;
    }
}

export default BillingReportReducer;
